export default function WhyChooseIreland() {
    return (
        <section className="w-full pb-16 px-4 sm:px-6 lg:px-16 bg-white">
            <div className="max-w-7xl mx-auto flex flex-col gap-8">

                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Why Consult an Ireland Education & Visa Expert?
                </h3>

                <div className="text-gray-800 text-base sm:text-lg leading-relaxed space-y-4">
                    <p>
                        Navigating the Irish education and visa process can be complex. Ireland Student Visa Consultants provide:
                    </p>

                    <ul className="list-disc pl-6 space-y-2">
                        <li><strong>University & Program Selection:</strong> Helping students choose the right courses and colleges.</li>
                        <li><strong>Application Assistance:</strong> Ensuring accurate and timely submission of applications, including UCAS or non-UCAS procedures.</li>
                        <li><strong>Portfolio Guidance:</strong> Preparing strong portfolios for specialized courses like arts and design.</li>
                        <li><strong>Accreditation & Compliance:</strong> Assistance with CAO and NFQ registration and ensuring courses meet official standards.</li>
                        <li><strong>Scholarship Support:</strong> Identifying government, university, and merit-based scholarships to reduce financial burden.</li>
                        <li><strong>Pre-Departure Orientation:</strong> Guidance on travel, cultural adaptation, accommodation, health insurance, and budgeting.</li>
                        <li><strong>Visa Assistance:</strong> Help with AVATS registration, application submission, and guidance on visa categories (Stamp 1, 2, 2A, etc.).</li>
                        <li><strong>Post-Arrival Support:</strong> Assistance with GNIB registration, IRP cards, and settling into Ireland.</li>
                    </ul>
                </div>

                <h3 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900">
                    Why Choose Shivasya for Ireland Student Visa Consultancy?
                </h3>

                <div className="text-gray-800 text-base sm:text-lg leading-relaxed space-y-4">
                    <p>
                        Shivasya is one of the leading Ireland Student Visa Consultants in Ahmedabad, providing end-to-end support for students wishing to study in Ireland. Our experts:
                    </p>

                    <ul className="list-disc pl-6 space-y-2">
                        <li>Keep you updated on the latest visa regulations</li>
                        <li>Guide you through pre-departure and post-arrival processes</li>
                        <li>Minimize errors in applications and documentation</li>
                        <li>Help choose the right visa category based on your study plan</li>
                        <li>Provide personalized counseling to match your career and educational goals</li>
                    </ul>

                    <p>
                        With Shivasya, students enjoy a seamless study abroad journey with peace of mind, from application to arrival in Ireland.
                    </p>

                    <p className="font-semibold">
                        Book a free consultation today and take the first step toward achieving your dream of studying in Ireland!
                    </p>
                </div>

            </div>
        </section>
    );
}